
var so = 'http://identifiers.org/so/'
var sbo = 'http://identifiers.org/biomodels.sbo/'

module.exports = {

    promoter: 'http://identifiers.org/so/SO:0000167',
    operator: 'http://identifiers.org/so/SO:0000057',
    cds: 'http://identifiers.org/so/SO:0000316',
    fivePrimeUtr: 'http://identifiers.org/so/SO:0000204',
    terminator: 'http://identifiers.org/so/SO:0000141',
    insulator: 'http://identifiers.org/so/SO:0000627',
    originOfReplication: 'http://identifiers.org/so/SO:0000296',
    primerBindingSite: 'http://identifiers.org/so/SO:0005850',
    ribosomeBindingSite: 'http://identifiers.org/so/SO:0000139',
    gene: 'http://identifiers.org/so/SO:0000704',
    rna: 'http://identifiers.org/so/SO:0000234',
    restrictionSite: 'http://identifiers.org/so/SO:0001687',
    bluntRestrictionSite: 'http://identifiers.org/so/SO:0001691',
    assemblyScar: 'http://identifiers.org/so/SO:0001953',
    engineeredGene: 'http://identifiers.org/so/SO:0000280',
    engineeredRegion: 'http://identifiers.org/so/SO:0000804',
    conservedRegion: 'http://identifiers.org/so/SO:0000330',

    dnaRegion: 'http://www.biopax.org/release/biopax-level3.owl#DnaRegion',
    rnaRegion: 'http://www.biopax.org/release/biopax-level3.owl#RnaRegion',
    protein: 'http://www.biopax.org/release/biopax-level3.owl#Protein',
    smallMolecule: 'http://www.biopax.org/release/biopax-level3.owl#SmallMolecule',
    effector: 'http://identifiers.org/chebi/CHEBI:35224',

    dnaSequence: 'http://www.chem.qmul.ac.uk/iubmb/misc/naseq.html',
    rnaSequence: 'http://www.chem.qmul.ac.uk/iubmb/misc/naseq.html',
    proteinSequence: 'http://www.chem.qmul.ac.uk/iupac/AminoAcid/',

    complex: 'http://www.biopax.org/release/biopax-level3.owl#Complex',

    sbo: {
        modelingFramework: sbo + 'SBO:0000004',
        continuousFramework: sbo + 'SBO:0000062',
        nonSpatialContinuousFramework: sbo + 'SBO:0000293',
        spatialContinuousFramework: sbo + 'SBO:0000292',
        discreteFramework: sbo + 'SBO:0000063',
        nonSpatialDiscreteFramework: sbo + 'SBO:0000295',
        spatialDiscreteFramework: sbo + 'SBO:0000294',
        fluxBalanceFramework: sbo + 'SBO:0000624',
        logicalFramework: sbo + 'SBO:0000234',
        booleanLogicalFramework: sbo + 'SBO:0000547',
        occurringEntityRepresentation: sbo + 'SBO:0000231',
        biologicalActivity: sbo + 'SBO:0000412',
        process: sbo + 'SBO:0000375',
        biochemicalOrTransportReaction: sbo + 'SBO:0000167',
        biochemicalReaction: sbo + 'SBO:0000176',
        acidBaseReaction: sbo + 'SBO:0000208',
        deprotonation: sbo + 'SBO:0000213',
        protonation: sbo + 'SBO:0000212',
        conformationalTransition: sbo + 'SBO:0000181',
        conversion: sbo + 'SBO:0000182',
        additionOfAChemicalGroup: sbo + 'SBO:0000210',
        acetylation: sbo + 'SBO:0000215',
        glycosylation: sbo + 'SBO:0000217',
        hydroxylation: sbo + 'SBO:0000233',
        methylation: sbo + 'SBO:0000214',
        myristoylation: sbo + 'SBO:0000219',
        palmitoylation: sbo + 'SBO:0000218',
        phosphorylation: sbo + 'SBO:0000216',
        prenylation: sbo + 'SBO:0000221',
        farnesylation: sbo + 'SBO:0000222',
        geranylgeranylation: sbo + 'SBO:0000223',
        sulfation: sbo + 'SBO:0000220',
        ubiquitination: sbo + 'SBO:0000224',
        cleavage: sbo + 'SBO:0000178',
        removalOfAChemicalGroup: sbo + 'SBO:0000211',
        deamination: sbo + 'SBO:0000401',
        decarbonylation: sbo + 'SBO:0000400',
        decarboxylation: sbo + 'SBO:0000399',
        dephosphorylation: sbo + 'SBO:0000330',
        transferOfAChemicalGroup: sbo + 'SBO:0000402',
        transamination: sbo + 'SBO:0000403',
        degradation: sbo + 'SBO:0000179',
        dissociation: sbo + 'SBO:0000180',
        hydrolysis: sbo + 'SBO:0000376',
        ionisation: sbo + 'SBO:0000209',
        isomerisation: sbo + 'SBO:0000377',
        nonCovalentBinding: sbo + 'SBO:0000177',
        redoxReaction: sbo + 'SBO:0000200',
        oxidation: sbo + 'SBO:0000201',
        reduction: sbo + 'SBO:0000202',
        transportReaction: sbo + 'SBO:0000185',
        transcellularMembraneEffluxReaction: sbo + 'SBO:0000588',
        transcellularMembraneInfluxReaction: sbo + 'SBO:0000587',
        biologicalEffectOfAPerturbation: sbo + 'SBO:0000357',
        compositeBiochemicalProcess: sbo + 'SBO:0000205',
        dnaReplication: sbo + 'SBO:0000204',
        geneticProduction: sbo + 'SBO:0000589',
        transcription: sbo + 'SBO:0000183',
        translation: sbo + 'SBO:0000184',
        encapsulatingProcess: sbo + 'SBO:0000395',
        molecularOrGeneticInteraction: sbo + 'SBO:0000342',
        geneticInteraction: sbo + 'SBO:0000343',
        geneticEnhancement: sbo + 'SBO:0000501',
        geneticSuppression: sbo + 'SBO:0000500',
        syntheticLethality: sbo + 'SBO:0000502',
        molecularInteraction: sbo + 'SBO:0000344',
        proteinComplexFormation: sbo + 'SBO:0000526',
        omittedProcess: sbo + 'SBO:0000397',
        phenotype: sbo + 'SBO:0000358',
        stateVariableAssignment: sbo + 'SBO:0000464',
        petriNetTransition: sbo + 'SBO:0000591',
        uncertainProcess: sbo + 'SBO:0000396',
        relationship: sbo + 'SBO:0000374',
        control: sbo + 'SBO:0000168',
        allostericControl: sbo + 'SBO:0000239',
        consumption: sbo + 'SBO:0000394',
        inhibition: sbo + 'SBO:0000169',
        absoluteInhibition: sbo + 'SBO:0000407',
        production: sbo + 'SBO:0000393',
        stimulation: sbo + 'SBO:0000170',
        absoluteStimulation: sbo + 'SBO:0000411',
        catalysis: sbo + 'SBO:0000172',
        necessaryStimulation: sbo + 'SBO:0000171',
        equivalence: sbo + 'SBO:0000392',
        logicalCombination: sbo + 'SBO:0000237',
        and: sbo + 'SBO:0000173',
        not: sbo + 'SBO:0000238',
        or: sbo + 'SBO:0000174',
        xor: sbo + 'SBO:0000175',
        logicalRelationship: sbo + 'SBO:0000398',
        positionalRelationship: sbo + 'SBO:0000413',
        cis: sbo + 'SBO:0000414',
        containment: sbo + 'SBO:0000469',
        trans: sbo + 'SBO:0000415',
        participantRole: sbo + 'SBO:0000003',
        functionalCompartment: sbo + 'SBO:0000289',
        modifier: sbo + 'SBO:0000019',
        dualActivityModifier: sbo + 'SBO:0000595',
        inhibitor: sbo + 'SBO:0000020',
        competitiveInhibitor: sbo + 'SBO:0000206',
        nonCompetitiveInhibitor: sbo + 'SBO:0000207',
        silencer: sbo + 'SBO:0000597',
        modifierOfUnknownActivity: sbo + 'SBO:0000596',
        stimulator: sbo + 'SBO:0000459',
        catalyst: sbo + 'SBO:0000013',
        enzymaticCatalyst: sbo + 'SBO:0000460',
        essentialActivator: sbo + 'SBO:0000461',
        bindingActivator: sbo + 'SBO:0000535',
        catalyticActivator: sbo + 'SBO:0000534',
        specificActivator: sbo + 'SBO:0000533',
        nonEssentialActivator: sbo + 'SBO:0000462',
        potentiator: sbo + 'SBO:0000021',
        neutralParticipant: sbo + 'SBO:0000594',
        product: sbo + 'SBO:0000011',
        sideProduct: sbo + 'SBO:0000603',
        promoter: sbo + 'SBO:0000598',
        reactant: sbo + 'SBO:0000010',
        interactor: sbo + 'SBO:0000336',
        substrate: sbo + 'SBO:0000015',
        sideSubstrate: sbo + 'SBO:0000604',
    },

    so: {
        promoter: so + 'SO:0000167',
        operator: so + 'SO:0000057',
        cds: so + 'SO:0000316',
        fivePrimeUtr: so + 'SO:0000204',
        terminator: so + 'SO:0000141',
        insulator: so + 'SO:0000627',
        originOfReplication: so + 'SO:0000296',
        primerBindingSite: so + 'SO:0005850',
        ribosomeEntrySite: so + 'SO:0000139',
        gene: so + 'SO:0000704',
        mRNA: so + 'SO:0000234',
        restrictionEnzymeRecognitionSite: so + 'SO:0001687',
        engineeredGene: so + 'SO:0000280',
        engineeredRegion: so + 'SO:0000804',
        sequenceFeature: so + 'SO:0000110',
        SGRNA: so + 'SO:0001998',
    }
}

